enum UserCampaignGroup {
  NLM1 = 'NLM1',
  NLM3 = 'NLM3',
}

export default UserCampaignGroup;
